import { Trash } from '@/resources/assets/images';
import { Dialog } from '@/components/atoms/Dialog';

import Button from '@/components/Button/newButtons';

export type RemoveNoteModalProps = {
	isOpen: boolean;
	onRemoveNote: VoidFunction;
	onCloseModal: VoidFunction;
};

export const RemoveNoteModal = ({
	isOpen,
	onRemoveNote,
	onCloseModal
}: RemoveNoteModalProps) => (
	<Dialog.Root open={isOpen} onOpenChange={onCloseModal}>
		<Dialog.Content className="gap-8 border-none">
			<Dialog.Title>Are you sure?</Dialog.Title>

			<Dialog.Description>
				Note will be permanently removed from this bussiness.
			</Dialog.Description>

			<Dialog.Footer>
				<Dialog.Close asChild>
					<Button variant="text">Cancel</Button>
				</Dialog.Close>

				<Dialog.Close asChild>
					<Button
						variant="secondary"
						onClick={onRemoveNote}
						red
						leftIcon={<Trash />}
					>
						Confirm Deletion
					</Button>
				</Dialog.Close>
			</Dialog.Footer>
		</Dialog.Content>
	</Dialog.Root>
);
